import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DividerModule } from 'primeng/divider';
import { PublicControllerService } from '../../services/generated/services/public-controller.service';

@Component({
  selector: 'app-custom-lending-doc-zip-download',
  standalone: true,
  imports: [CommonModule, FormsModule, DividerModule],
  templateUrl: './custom-lending-doc-zip-download.component.html',
  styleUrl: './custom-lending-doc-zip-download.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomLendingDocZipDownloadComponent implements OnInit {
  token: string = ''; 
  message: string = '';
  status: string = '';
  lendingDocData: any;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private publicService: PublicControllerService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.token = params.get('token') || ''; // Handle case where token might not be present
    });
    this.isLoading = true;
    this.publicService.downloadFilesZip({ body: { "applicationId": this.token} }).subscribe({
      next: (blob: any) => {
        this.isLoading = false;
        if (blob instanceof Blob && blob.size === 0) {
          this.status = 'info';
          this.message = 'No document found';
          this.changeDetectorRef.detectChanges();
          return;
        }
        if (blob) {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `client_documents.zip`;
            a.click();
            window.URL.revokeObjectURL(url);
        } else {
          this.status = 'error';
          this.message = 'Failed to download documents';
          this.changeDetectorRef.detectChanges();
        }
      }, error: async (err: any) => {
        this.isLoading = false;
        this.status = 'error';
        let msg = 'No document found';

        try {
          const blob: Blob | null = err?.error instanceof Blob ? err.error : (err instanceof Blob ? err : null);
          if (err?.error == null && blob?.size === 0) {
            // msg already initialized to 'No document found'
          } else {
            console.log(err?.error?.message || err?.message || msg);
          }
        } catch (e) {
          console.error('Error while reading error body', e);
        }

        this.message = msg;
        console.error(err);
        this.changeDetectorRef.detectChanges();
      }
    });
  }

}
